import { LOCATION_CHANGE } from "react-router-redux";
import analytics from "web_modules/utils/segment";

const segment = () => next => action => {
  if (action.type !== LOCATION_CHANGE) {
    return next(action);
  }

  const {
    payload: { pathname },
  } = action;

  analytics.page(pathname);

  /**
   * Since we're doing something on a React Router action,
   * we still need to pass the action through
   * so that the React Router middleware can act on it.
   */
  return next(action);
};

export default segment;
